import React, { useEffect } from "react";
import "./privacyAndTerms.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import { flower, sun } from "../../source";
import { privacypolicyURL } from "../../helpers/constants";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <section className="privacyandterms_sec1">
        <CommonBanner
          title="Terms & Conditions"
          linkText1="Terms & Conditions"
        />
      </section>

      <section className="privacyandterms_sec2 terms_container">
        <img src={sun} alt="sun" className="sun_img" />
        <img src={flower} alt="flower" className="flower_img" />
        <div className="content_wrapper">
          <div className="para_wrapper">
            <p className="section_desc22">
              Welcome to <b>Pathways and Perspectives</b> ("we," "our," or
              "us"). These Terms and Conditions ("Terms") govern your use of our{" "}
              <a href="/" className="Link_terms_privacy">
                website
              </a>
              , including all video content, blog posts, and any future events
              hosted by us. By accessing or using our platform, you agree to
              comply with these Terms. If you do not agree, please do not use
              our services.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">1. Use of Our Platform</h2>
            <p className="section_desc22">
              <b>Permitted Use</b> <br />
              You may use our website, video content, and blog posts for
              personal, non-commercial purposes. Any unauthorized use, including
              copying, reproducing, or distributing our content without
              permission, is strictly prohibited.
            </p>
            <p className="section_desc22">
              <b>Event Participation</b> <br />
              If you register for an event hosted by{" "}
              <b>Pathways and Perspectives</b>, you agree to abide by any
              additional event-specific terms, including safety guidelines,
              payment requirements, and cancellation policies.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">
              2. Content Ownership and Copyright
            </h2>
            <p className="section_desc22">
              <b>Intellectual Property</b> <br />
              All content on our platform, including videos, blogs, graphics,
              logos, and event materials, is the property of{" "}
              <b> Pathways and Perspectives</b> or its content creators.
              Unauthorized use, reproduction, or distribution is strictly
              prohibited.
            </p>
            <p className="section_desc22">
              <b>User-Generated Content</b> <br />
              If you submit content (e.g., comments, posts, or videos) to our
              platform, you grant us a non-exclusive, worldwide, royalty-free
              license to use, display, and distribute your content. You are
              responsible for ensuring that your submissions do not infringe on
              any third-party rights.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">
              3. Disclaimers and Limitation of Liability
            </h2>
            <p className="section_desc22">
              <b>Content Accuracy</b> <br />
              Our content is created for informational and entertainment
              purposes. While we strive for accuracy, we do not guarantee the
              completeness or reliability of any information provided.
            </p>
            <p className="section_desc22">
              <b>No Liability for Third-Party Links</b> <br />
              Our website may contain links to third-party websites. We are not
              responsible for the content, privacy policies, or practices of
              those websites.
            </p>
            <p className="section_desc22">
              <b>Event Disclaimer</b> <br />
              By attending any of our events, you acknowledge that you
              participate at your own risk. We are not liable for any injuries,
              damages, or losses incurred during an event.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">
              4. Privacy and Data Collection
            </h2>
            <p className="section_desc22">
              <b>Personal Data</b> <br />
              By using our platform, you agree to our{" "}
              <Link to={privacypolicyURL} className="Link_terms_privacy">
                <b>Privacy Policy</b>
              </Link>
              , which explains how we collect, use, and protect your data.
            </p>
            <p className="section_desc22">
              <b>Tracking and Analytics</b> <br />
              We may use analytics tools to track user engagement with our
              content. By using our platform, you consent to such tracking.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">5. Termination of Use</h2>
            <p className="section_desc22">
              We reserve the right to suspend or terminate your access to our
              platform if you violate these Terms or engage in unlawful
              activity.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">6. Changes to These Terms</h2>
            <p className="section_desc22">
              We may update these Terms from time to time. Any changes will be
              posted on this page with an updated "Last Updated" date. Your
              continued use of our platform constitutes acceptance of the
              revised Terms.
            </p>
          </div>

          <div className="para_wrapper">
            <h2 className="section_heading32">7. Contact Us</h2>
            <p className="section_desc22">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="section_desc22">
              <a
                href="mailto:seek@pathwaysperspectives.com"
                className="Link_terms_privacy"
              >
                seek@pathwaysperspectives.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditions;
